export const GOOGLE_AUTH_CLIENT_ID = import.meta.env.VITE_GOOGLE_AUTH_CLIENT_ID

export const LOGIN_DEFAULT_REDIRECT = '/'
